module.exports = __webpack_public_path__ + "static/media/rocket3.a1704019.png";